module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6w66u"))).then(() => parcelRequire('hEqeo'));